export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20urban%20streetwear%20fashion%20collage%20with%20bold%20sneakers%20oversized%20hoodies%20and%20colorful%20accessories%20on%20dark%20textured%20asphalt%20background%2C%20dramatic%20golden%20sunset%20lighting%2C%20editorial%20fashion%20photography%2C%20high%20contrast%20vibrant%20energy%2C%20young%20urban%20culture%20aesthetic&width=1600&height=900&seq=hero-pandabuy-v2&orientation=landscape"
          alt="Pandabuy Spreadsheet fashion finds collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20 pb-12">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs font-medium text-foreground-700">Updated Daily — 2026 Edition</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 leading-[1.08] mb-6 max-w-3xl mx-auto">
          Find the Best <span className="italic">Pandabuy Spreadsheet</span> Finds in 2026
        </h1>

        <p className="text-base md:text-lg text-background-200/90 mb-10 max-w-2xl mx-auto leading-relaxed font-light">
          Discover curated Pandabuy spreadsheet collections with trending fashion, shoes, hoodies, streetwear &amp; accessories.
          Compare prices, quality, and shipping times all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-950 rounded-full text-base font-semibold hover:bg-background-100 transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
          >
            Pandabuy Sheet
            <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-bag-line text-lg group-hover:translate-x-0.5 transition-transform"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-12 text-background-200/80 text-xs md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Trusted by 10,000+ Shoppers
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Updated Daily
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Curated Product Lists
          </span>
        </div>
      </div>
    </section>
  );
}